var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-user",
  "use": "ring-icon-user-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-user\"><circle cx=\"6.562\" cy=\"4.566\" r=\"3.691\" /><path d=\"M12.92 14a2.39 2.39 0 0 0 .027-.353A4.23 4.23 0 0 0 8.73 9.428H4.22A4.23 4.23 0 0 0 0 13.648 2.39 2.39 0 0 0 .028 14z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id